<template>
  <div>
    {{ tmpValue }}
    <a class="ml-2 pointer recounter"
       v-b-tooltip.hover
       :title="$t('recalculate')"
       @click="refreshCount">
      <RefreshSvg class="svg-light svg-size-lg"/>
    </a>
  </div>
</template>

<script setup>
import RefreshSvg from '@/assets/svg-vue/general/refresh2.svg'
import { MarketingService } from "@/services/api/marketing.api.service"
import { computed, onMounted, ref } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  object: {
    type: Object
  }
})

const store = useStore()

const tmpValue = ref(null)
const loading = computed(() => store.state.dom.loading)

onMounted(() => {
  tmpValue.value = props.object.patientsCount
})

const refreshCount = async () => {
  if(loading.value) return
  const res = await MarketingService.recountGroup(props.object.id)
  if(res.data?.count !== undefined) {
    tmpValue.value = res.data.count
  }
}
</script>

<style scoped lang="scss">
.recounter {
  opacity: 0.5;
}
</style>
